const state = {
  fluidsList: [],
  refrigerantsList: []
};

export default state;
